<style>
.fa-beat {
  animation: beat 1s infinite;
}

@keyframes beat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}

.fa-fade {
  animation: fade 1s infinite;
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper" style="padding-bottom: 0rem">
        <div class="col-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Productos Pendientes de Pedir</h5>
            <div class="row">
              <div class="col-4">
                <TiendaSelectComponent :current="current" />
              </div>
              <div class="col-4">
                <CategoriaSelectComponent :current="current" />
              </div>
              <div class="col-sm-4">
                <ProductoSelectComponentV2 :current="current" />
              </div>
              <div class="col-12 btn-group">
                <button
                  class="btn btn-md btn-success"
                  @click="refresh"
                  v-if="current.tienda"
                >
                  Refrescar Busqueda
                </button>
                <button class="btn glow-on-hover btn-md" @click="abrirModalSolicitudes()">
                  Generar solicitudes por tienda <i class="far fa-paper-plane"></i>
                </button>
                <button class="btn btn-md btn-info" @click="cleanFilters">
                  Limpiar Busqueda &nbsp; <i class="fas fa-sync"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="element-box">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>producto</th>
                  <th>Tienda</th>
                  <th>Categoría</th>
                  <th class="text-right">Minimo</th>
                  <th class="text-right">Maximo</th>
                  <th class="text-right">Existencia</th>
                  <th class="text-right">Cantidad Abierta</th>
                  <th>Unidad medida</th>
                  <th class="text-right">Cantidad Pedir um</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in datos" :key="item.id">
                  <td>
                    <span style="color: brown">{{ item.producto_id }}</span> -
                    {{ item.nombre_producto }}
                  </td>
                  <td>{{ item.tienda_id }}</td>
                  <td>{{ item.nombre_categoria }}</td>
                  <td class="text-right">{{ item.minimo }}</td>
                  <td class="text-right">{{ item.maximo }}</td>
                  <td class="text-right">{{ item.existencia }}</td>
                  <td class="text-right">{{ item.cantidad_abierta }}</td>
                  <td>{{ item.unidad_medida }}</td>
                  <td class="text-right" style="color: blue">
                    {{ item.pedir_um }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalGenerarSolicitudes"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div style="background-color: #B1E3B1" class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Seleccione las tiendas a solicitar
            </h5>
            <button
              v-if="process == false"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div >
            <div
              v-if="view_all == true"
              class="col-11"
              style="display: flex; justify-content: flex-end"
            >
              <small>Todo &nbsp;</small
              ><input
                v-if="view_all == true"
                v-model="selectAll"
                @input="selectTodas()"
                type="checkbox"
              />
            </div>
            <div style="overflow-y: scroll; max-height: 420px" class="modal-body">
              <table class="table table-striped">
                <thead>
                  <th>Tienda</th>
                  <th class="text-center">Cantidad</th>
                  <th class="text-center">Estatus</th>
                  <th class="text-center">selección</th>
                </thead>
                <tbody>
                  <tr v-for="(td, index) in tiendas" :key="td.id">
                    <td>{{ td.codigo }} - {{ td.nombre }}</td>
                    <td class="text-center">{{ td.solicitudes_generadas }}</td>
                    <td class="text-center">
                      <i
                        v-if="td.permite_traslados == 'process'"
                        class="fas fa-sync-alt fa-spin fa-2x text-success"
                      ></i>
                      <i
                        v-if="td.permite_traslados == 'success'"
                        class="fas fa-check fa-fade fa-2x text-success"
                      ></i>
                      <i
                        v-if="td.permite_traslados == 'error'"
                        class="fas fa-times fa-fade fa-2x text-danger"
                      ></i>
                    </td>
                    <td class="text-center">
                      <input
                        ref="checkboxes"
                        @change="selectTienda(td, index)"
                        type="checkbox"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="process == false"
              type="button"
              class="btn btn-secondary"
              @click="Reset()"
            >
              Resetear <i class="fas fa-sync"></i>
            </button>
            <button
              v-if="process == false"
              type="button"
              class="btn btn-secondary"
              @click="cerrar()"
            >
              Cerrar <i class="fas fa-door-open"></i>
            </button>
            <button
              v-if="process == false"
              @click="generarSolicitudesAutomaticas()"
              type="button"
              class="btn btn-success"
            >
              Generar solicitudes <i class="far fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponentV2,
    CategoriaSelectComponent,
  },
  data() {
    return {
      seleccionadas: [],
      view_all: false,
      selectAll: false,
      tiendas: [],
      process: false,
      tiendas_solicitar: [],
      current: {
        tienda: null,
        producto: "",
        categoria: "",
        errors: {
          productos: null,
        },
      },
      datos: [],
      categorias: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
    self.refreshTiendas();
    self.tiendas = [];
    self.process = false;
    self.tiendas_solicitar = [];
  },
  methods: {
    cerrar() {
      let self = this;
      $("#modalGenerarSolicitudes").modal("hide");
      self.seleccionadas = [];
      self.selectAll = false;
      self.refreshTiendas();
      self.$refs.checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    },
    tiendasSugeridas() {
      let self = this;
      const tiendas_sugeridas = [
        "04",
        "05",
        "06",
        "08",
        "09",
        "15",
        "20",
        "21",
        "22",
        "23",
      ];
      self.tiendas = self.tiendas.filter((item) =>
        tiendas_sugeridas.includes(item.codigo)
      );
    },
    selectTodas() {
      let self = this;
      if (self.selectAll == true) {
        self.seleccionadas = [];
        self.$refs.checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
        self.selectAll = false;
        return;
      }
      const tiendas_sugeridas = [
        "04",
        "05",
        "06",
        "08",
        "09",
        "15",
        "20",
        "21",
        "22",
        "23",
      ];
      for (let i in tiendas_sugeridas) {
        let index_sugerido = self.tiendas.findIndex(
          (item) => item.codigo === tiendas_sugeridas[i]
        );
        self.selectTienda(self.tiendas[index_sugerido], index_sugerido);
      }
      this.$refs.checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
      self.selectAll = true;
    },
    Reset() {
      let self = this;
      self.refreshTiendas();
      self.seleccionadas = [];
      self.selectAll = false;
      this.$refs.checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    },
    selectTienda(td, index) {
      let self = this;
      self.tiendas[index].permite_traslados = "stand_by";
      if (self.tiendas_solicitar.includes(td)) {
        self.tiendas_solicitar = self.tiendas_solicitar.filter((item) => item !== td);
        td.permite_traslados = "stand_by";
        self.tiendas[index].permite_traslados = null;
        return;
      }
      self.tiendas_solicitar.push(td);
    },
    refreshTiendas() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    generarSolicitudesAutomaticas() {
      let self = this;
      Notifications.alert.confirm(
        "Generar solicitudes automaticas",
        "¿Esta Seguro?",
        "Si Abrir",
        function () {
          self.generarSolicitudesAutomaticas_();
        }
      );
    },
    generarSolicitudesAutomaticas_() {
      let self = this;
      self.process = true;
      let _tienda = self.tiendas_solicitar.filter(
        (item) => item.permite_traslados == "stand_by"
      );
      if (_tienda.length == 0) {
        self.process = false;
        self.view_all = false;
        return;
      }
      _tienda = _tienda[0];
      let index = self.tiendas.findIndex((item) => item === _tienda);
      self.tiendas[index].permite_traslados = "process";
      let index_solicitar = self.tiendas_solicitar.findIndex((item) => item === _tienda);
      self.tiendas_solicitar[index_solicitar].permite_traslados = "process";

      DynamicService.getActionList("inv", "req_traslado", "solicitud_automatica", {
        tienda: _tienda.codigo,
      })
        .then((response) => {
          self.tiendas_solicitar[index_solicitar].permite_traslados = "success";
          self.tiendas[index].permite_traslados = "success";
          self.tiendas[index].solicitudes_generadas =
            response.data[0].solicitudes_generadas;
          self.process = false;
          self.generarSolicitudesAutomaticas_();
        })
        .catch((error) => {
          self.tiendas_solicitar[index_solicitar].permite_traslados = "error";
          self.tiendas[index].permite_traslados = "error";
          Notifications.alert.error("Generar Solicitudes Automaticas", "ERROR");
          self.generarSolicitudesAutomaticas_();
        });
    },
    abrirModalSolicitudes() {
      let self = this;
      Notifications.alert.confirm(
        "Quiere utilizar solo las tiendas sugeridas",
        "¿Esta Seguro?",
        "Si",
        function () {
          self.tiendasSugeridas();
          self.view_all = true;
        }
      );
      $("#modalGenerarSolicitudes").modal("show");
    },
    cleanFilters() {
      this.current.tienda = null;
      this.current.producto = null;
      this.current.categoria = null;
      this.datos = "";
    },

    refresh() {
      let self = this;
      let tienda = null;
      let sku = null;
      let categoria = null;
      if (this.current.tienda) {
        tienda = this.current.tienda;
      }
      if (this.current.producto) {
        sku = this.current.producto.sku;
      }
      if (this.current.categoria) {
        categoria = this.current.categoria.codigo;
      }
      console.log(this.current.categoria);
      let params = {
        tienda: tienda,
        sku: sku,
        categoria: categoria,
      };
      DynamicService.getActionList("inv", "req_traslado", "vw_a_pedir", params)
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
